import { createContext, useContext } from 'react';

interface EditorContextValue {
  comment: string;
  handleCommentChange: (value: string) => void;
  mdeInstance: any | null;
  setMdeInstance: (instance: any) => void;
}

export const EditorContext = createContext<EditorContextValue>({
  comment: '',
  handleCommentChange: () => {},
  mdeInstance: null,
  setMdeInstance: () => {},
});

export const useEditor = () => useContext(EditorContext);
